import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiRatesCertificateConstants } from "../../constants/api-constants/api-rates-certificate.constants";
let RatesCertificateService = class RatesCertificateService {
    http;
    constructor(http) {
        this.http = http;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiRatesCertificateConstants.URL}/${applicationId}/${ApiRatesCertificateConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
RatesCertificateService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RatesCertificateService);
export { RatesCertificateService };
